import { render, staticRenderFns } from "./ProbnaPrijavaPitanjaSingle.vue?vue&type=template&id=36d0dcfc&scoped=true&"
import script from "./ProbnaPrijavaPitanjaSingle.vue?vue&type=script&lang=js&"
export * from "./ProbnaPrijavaPitanjaSingle.vue?vue&type=script&lang=js&"
import style0 from "./ProbnaPrijavaPitanjaSingle.vue?vue&type=style&index=0&id=36d0dcfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0dcfc",
  null
  
)

export default component.exports